import { useAppStore } from '.'
import { getLocalForage } from '../../general/helper'

const localForage = getLocalForage()

export const storeBosysReference = async (ref: string | null) => {
  const appStore = useAppStore()

  await localForage!.getItem('bosysReference', async (_error, value: string | null) => {
    if (!value) {
      await localForage!.setItem('bosysReference', ref)
      appStore.bosysReference = ref
    }
  })
}

export const loadBosysReference = async () => {
  const appStore = useAppStore()

  await localForage!.getItem('bosysReference', async (_error, value: string | null) => {
    appStore.bosysReference = value
    await localForage!.setItem('bosysReference', null)
  })
}

export default {
  storeBosysReference,
  loadBosysReference,
}